// extracted by mini-css-extract-plugin
module.exports = {"slimHero":"slimHero_slimHero__oUej9","imageWrapper":"slimHero_imageWrapper__RIYII","content":"slimHero_content___bdjY","heading":"slimHero_heading__j3QeI"};